import React, { useState, useEffect } from 'react';
import _get from 'lodash/get';
import { client } from 'cccisd-apollo';
import Loader from 'cccisd-loader';
import familyMembersQuery from './familyMembers.graphql';
import { renderFamilyMemberName } from '../../helpers/tfhParent.js';
import Report from './Report.js';

const Fortress = window.cccisd.fortress;

const TrackingReport = props => {
    const [isLoading, setIsLoading] = useState(true);
    const [pawnInfo, setPawnInfo] = useState(null);
    const [familyMemberPickerInfo, setFamilyMemberPickerInfo] = useState(null);
    const [isLoadingReportData, setIsLoadingReportData] = useState(false);
    const [reportData, setReportData] = useState(null);

    useEffect(() => {
        async function getFamilyPickerInfo() {
            const resp = await client.query({
                query: familyMembersQuery,
                variables: {
                    familyId: Fortress.user.acting.group.id,
                    familyRandomHash: Fortress.user.acting.group.random_hash,
                },
                fetchPolicy: 'network-only',
            });

            setFamilyMemberPickerInfo(_get(resp, 'data.roles.anyRoleList', []) || []);
        }

        if (props.pawnId && props.pawnHash && props.displayName) {
            setPawnInfo({ ...props });
        } else {
            getFamilyPickerInfo();
        }

        setIsLoading(false);
    }, []);

    async function fetchReportData() {
        if (!pawnInfo) {
            return;
        }

        setIsLoadingReportData(true);
        // get data
        setReportData('foo');
        setIsLoadingReportData(false);
    }

    useEffect(() => {
        fetchReportData();
    }, [pawnInfo]);

    function renderFamilyMemberPicker() {
        if (!familyMemberPickerInfo || !Array.isArray(familyMemberPickerInfo)) {
            return <span />;
        }

        return (
            <div className="mb-5">
                <label className="form-label" htmlFor="familyMember">
                    Choose family member:
                </label>
                <select
                    id="familyMember"
                    name="familyMember"
                    value={pawnInfo?.pawn?.pawnId || -1}
                    className={`form-select ${!pawnInfo && 'fw-light fst-italic text-body-tertiary'}`}
                    style={{ width: 'fit-content', minWidth: '300px' }}
                    aria-label="Family Member"
                    onChange={event => {
                        const memberInfo = familyMemberPickerInfo.find(
                            mem => parseInt(mem.pawn.pawnId, 10) === parseInt(event.target.value, 10)
                        );
                        setPawnInfo(memberInfo);
                    }}
                >
                    {!pawnInfo && (
                        <option value="-1" disabled>
                            -- choose family member --
                        </option>
                    )}
                    {familyMemberPickerInfo.map(p => (
                        <option key={p.pawn.pawnId} value={p.pawn.pawnId}>
                            {renderFamilyMemberName(p, familyMemberPickerInfo)}
                        </option>
                    ))}
                </select>
            </div>
        );
    }

    function renderReport() {
        if (!pawnInfo) {
            return null;
        }

        if (isLoadingReportData || !reportData) {
            return <Loader type="inline" loading />;
        }

        return <Report reportData={reportData} />;
    }

    return (
        <Loader loading={isLoading}>
            {renderFamilyMemberPicker()}
            {renderReport()}
        </Loader>
    );
};

export default TrackingReport;
